<template>
  <div id="app">
    <div v-if="isPublicPage">
      <router-view />
    </div>
    <div v-else-if="isLoggedIn">
      <Navbar />
      <Sidebar />
      <div class="main-content">
        <div class="page-content">
          <div class="page-section">
            <div class="container page__container">
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import Sidebar from './components/Ui/Sidebar.vue';
import Navbar from './components/Ui/Navbar.vue';

const DEFAULT_FAVICON = '/favicon.png';

export default {
  name: 'App',
  components: { Sidebar, Navbar },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'getLoggedInUser']),
    isPublicPage() {
      return this.$route.name === 'sign-contract';
    },
  },
  watch: {
    isLoggedIn(val) {
      if (val) {
        this.applyBranding();
      } else {
        this.resetBranding();
      }
    },
  },
  methods: {
    ...mapActions('navbarConfig', ['updateNavbarBrandDetails']),

    applyBranding() {
      const school = get(this.getLoggedInUser, 'school');
      if (school) {
        if (school.primary_color) {
          document.documentElement.style.setProperty('--primary-color', school.primary_color);
        }
        if (school.secondary_color) {
          document.documentElement.style.setProperty('--secondary-color', school.secondary_color);
        }
        if (school.dark_color) {
          document.documentElement.style.setProperty('--dark-color', school.dark_color);
        }
        const favicon = document.getElementById('favicon');
        if (favicon) {
          favicon.href = get(school, 'small_logo_url') || DEFAULT_FAVICON;
        }
        this.updateNavbarBrandDetails(school);
      }
    },

    resetBranding() {
      document.documentElement.style.setProperty('--primary-color', '#3B86F5');
      document.documentElement.style.setProperty('--secondary-color', '#2F6FED');
      document.documentElement.style.setProperty('--dark-color', '#181818');
      const favicon = document.getElementById('favicon');
      if (favicon) {
        favicon.href = DEFAULT_FAVICON;
      }
    },
  },
  beforeMount() {
    if (this.isLoggedIn) {
      this.applyBranding();
    }
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Inter', 'DM Sans', 'Source Sans Pro', -apple-system, BlinkMacSystemFont,
    'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
    'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}
</style>
